<template>
  <div>
    <v-card>
      <v-toolbar color="transparent" flat>
        <v-toolbar-title>Listagem de Pacotes</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="this.create">
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-layout px-4 wrap>
        <v-flex md12>
          <v-list two-line>
            <template v-for="(item, i) in data">
              <v-divider v-if="i > 0" :key="`divider_${item.id}`"></v-divider>
              <v-list-item
                ripple
                :key="`tile_${item.id}`"
                @click="load(item.id)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    item.price | money
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-tooltip max-width="350" left>
                    <template v-slot:activator="{ on }">
                      <v-icon color="grey lighten-1" v-on="on">info</v-icon>
                    </template>
                    <span>{{ item.description }}</span>
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card>
    <v-dialog v-model="isPackageFormVisible" persistent max-width="800px">
      <v-card>
        <v-card-title class="headline">Pacote</v-card-title>
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-flex md9>
              <v-text-field
                name="name"
                label="Nome"
                id="name"
                v-model="formModel.package.name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <MoneyInput
                name="price"
                label="Preço"
                id="price"
                v-model="formModel.package.price"
              ></MoneyInput>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md12>
              <v-textarea
                name="description"
                label="Descrição"
                id="description"
                v-model="formModel.package.description"
                required
              ></v-textarea>
            </v-flex>
          </v-layout>
          <div v-if="this.formModel.package.id > 0">
            <v-divider></v-divider>
            <v-layout wrap>
              <v-flex md12>
                <v-list two-line>
                  <template v-for="(item, i) in stays">
                    <v-divider
                      v-if="i > 0"
                      :key="`divider_stay_${item.id}`"
                    ></v-divider>
                    <v-list-item
                      ripple
                      :key="`tile_stay_${item.id}`"
                      @click="enterStayDetails(item)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ getHotelName(item.id) }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ item.city }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-flex>
            </v-layout>
          </div>
        </v-container>
        <v-card-actions>
          <v-btn
            icon
            @click="confirmRemove()"
            v-if="this.formModel.package.id > 0"
            ><v-icon>delete</v-icon></v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="cancel">Cancelar</v-btn>
          <v-btn color="primary" text @click="save">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isPackageStayDetailsVisible"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-card-title class="title"
          >Hotel em {{ selectedStay.city }}</v-card-title
        >
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-flex md12>
              <v-text-field
                name="hotelName"
                label="Nome do Hotel"
                placeholder="Sem Hotel"
                id="hotelName"
                v-model="selectedStayDetails.hotelName"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="isPackageStayDetailsVisible = false"
            >Cancelar</v-btn
          >
          <v-btn color="primary" text @click="saveStayDetails">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <OperationStatusCard
      ref="loadingStatusCard"
      progressMessage="Carregando"
      successMessage="Pronto"
      errorMessage="Falha ao carregar"
    />
    <OperationStatusCard
      ref="executingStatusCard"
      progressMessage="Operação em progresso"
      successMessage="Pronto"
      errorMessage="Falha ao executar operação"
    />
    <ConfirmDialog
      id="confirmDeleteDialog"
      ref="confirmDeleteDialog"
      title="Excluir Registro"
      :message="
        `Deseja realmente excluir o pacote ${this.formModel.package.name}?`
      "
      yes-button="Sim"
      no-button="Não"
      @confirm="remove"
    />
  </div>
</template>
<script>
import api from "@/api";
import ConfirmDialog from "@/components/Shared/ConfirmDialog";
import MoneyInput from "@/components/Shared/MoneyInput";
import OperationStatusCard from "@/components/Shared/OperationStatusCard";
export default {
  name: "PackageManagement",
  components: {
    ConfirmDialog,
    MoneyInput,
    OperationStatusCard
  },
  props: ["tripId", "stays"],
  data() {
    return {
      isPackageFormVisible: false,
      formModel: {
        package: {
          price: 0
        },
        stayDetails: []
      },
      isPackageStayDetailsVisible: false,
      selectedStay: {},
      selectedStayDetails: {},
      data: []
    };
  },
  methods: {
    create() {
      this.formModel = {
        package: {
          price: 0
        },
        stayDetails: []
      };
      this.isPackageFormVisible = true;
    },
    save() {
      this.$refs.executingStatusCard.show();
      var endpoint = this.formModel.package.id
        ? `/trips/${this.tripId}/package/${this.formModel.package.id}`
        : `/trips/${this.tripId}/package`;
      var method = this.formModel.package.id ? "PUT" : "POST";
      api
        .request(method, endpoint, this.formModel.package)
        .then(() => {
          this.isPackageFormVisible = false;
          this.$refs.executingStatusCard.succeed();
          this.loadAll();
        })
        .catch(error => {
          this.$refs.executingStatusCard.fail(error.response.data);
        });
    },
    confirmRemove() {
      this.$refs.confirmDeleteDialog.show();
    },
    remove() {
      this.$refs.executingStatusCard.show();
      api
        .request(
          "DELETE",
          `/trips/${this.tripId}/package/${this.formModel.package.id}`
        )
        .then(() => {
          this.isPackageFormVisible = false;
          this.$refs.executingStatusCard.succeed();
          this.loadAll();
        })
        .catch(error => {
          this.$refs.executingStatusCard.fail(error.response.data);
        });
    },
    enterStayDetails(stay) {
      this.isPackageStayDetailsVisible = true;

      var filtered = this.formModel.stayDetails.filter(
        p => p.stayId == stay.id
      );

      this.selectedStay = stay;
      if (filtered.length == 0) {
        this.selectedStayDetails = {
          packageId: this.formModel.package.id,
          stayId: stay.id
        };
      }

      this.selectedStayDetails = filtered[0] || this.selectedStayDetails;
    },
    saveStayDetails() {
      this.$refs.executingStatusCard.show();
      api
        .request(
          "POST",
          `/trips/${this.tripId}/package/
          ${this.selectedStayDetails.packageId}
          /stay/${this.selectedStayDetails.stayId}`,
          this.selectedStayDetails
        )
        .then(() => {
          this.$refs.executingStatusCard.close();
          this.isPackageStayDetailsVisible = false;
          this.load(this.selectedStayDetails.packageId);
        })
        .catch(error => {
          this.$refs.executingStatusCard.fail(error.response.data);
        });
    },
    getHotelName(stayId) {
      var filtered = this.formModel.stayDetails.filter(p => p.stayId == stayId);
      if (filtered.length == 0) {
        return "-";
      }
      return filtered[0].hotelName;
    },
    load(id) {
      this.$refs.loadingStatusCard.show();
      api
        .request("GET", `/trips/${this.tripId}/package/${id}`)
        .then(response => {
          this.$refs.loadingStatusCard.close();
          this.formModel = response.data;
          this.isPackageFormVisible = true;
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    },
    cancel() {
      this.isPackageFormVisible = false;
      this.loadAll();
    },
    loadAll() {
      if (this.tripId) {
        this.isDataLoading = true;
        api
          .request("GET", `/trips/${this.tripId}/package`)
          .then(response => {
            this.data = response.data.packages;
            this.$emit("loaded", this.data);
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.isDataLoading = false;
          });
      }
    }
  },
  mounted() {
    this.loadAll();
  }
};
</script>
